import type { AtlassianAccountUser } from '../../types';
import { safelyParseUserAri } from '../ari';

export const isAtlassianAccountUser = (entity: any): entity is AtlassianAccountUser =>
	entity.__typename === 'AtlassianAccountUser';

export const getAtlassianAccountUserLink = (
	user: AtlassianAccountUser,
	orgHomeUrl: string,
	cloudId: string,
): string | null => {
	const userAri = safelyParseUserAri(user.id);
	if (!userAri) {
		return null;
	}

	return `${orgHomeUrl}/people/${userAri.resourceId}?cloudId=${cloudId}`;
};
